/**
 * Build-time environment helpers for iris-ops.
 *
 * Scraper fleet data is only collected for prod. The dev deployment of iris-ops
 * (ops.dev.iris26.variableq.com) must not render scraper UI at all — any empty
 * or stale data there would be misleading.
 *
 * VITE_IRIS_ENV is wired through bitbucket-pipelines.yml -> Dockerfile ARG -> Vite.
 */

export type IrisEnv = "prod" | "dev";

export function getIrisEnv(): IrisEnv {
  return import.meta.env.VITE_IRIS_ENV === "prod" ? "prod" : "dev";
}

export function isProdBuild(): boolean {
  return getIrisEnv() === "prod";
}
